import React, { Component } from 'react';

class handle_3d extends Component {
  constructor(props){
    super(props);
    this.state = {
      
    };
  }
  componentDidMount(){
    var url_string = window.location.href;
    var url = new URL(url_string);
    console.log("######## handle_3d #############")
    console.log(window.location)
    localStorage.popup_3d_secure = true;
    // if(url.searchParams.get("3ds")){
    //     localStorage.popup_3d_secure = true;
    // }else{
      
    // }
  }
  render() {
    return(
      <div className="handle_3d">
        <h1>Loading...</h1>
      </div>
    )
  }
}

export default handle_3d;
